import moment from 'moment';
import { prevBusinessDay } from '@melio/melio-business-days';

const workingDays = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5
};
moment.updateLocale('us', {
  workingWeekdays: Object.values(workingDays)
});

export const lastBusinessDay = moment(prevBusinessDay(new Date()));
